import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { getUniqueString } from "../../lib/utils.js";
import { idMap } from "../../lib/utils_vue.js";
import { Fragment, createBlock, createElementBlock, createElementVNode, createVNode, openBlock, renderList, renderSlot, resolveComponent, unref, withCtx } from "vue";
import { DtButton } from "@dialpad/dialtone-vue";
import { DtIconClose, DtIconPlus } from "@dialpad/dialtone-icons/vue";
//#region src/components/controls/control_iterable.vue
var _hoisted_1 = { class: "d-fl-grow1" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlIterable" }, {
	props: {
		value: {
			type: Array,
			required: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		generateItem: {
			type: Function,
			required: true
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		/**
		* Id map is used to keep v-for keys in order when adding and removing new items.
		*/
		const { addId, removeId, getId } = idMap(`${getUniqueString(`dtc-control-iterable`)}-item`);
		function updateItem(index, item) {
			const items = [...props.value];
			items.splice(index, 1, item);
			updateValue(items);
		}
		function addItem() {
			const items = [...props.value, props.generateItem()];
			addId();
			updateValue(items);
		}
		function removeItem(index) {
			const items = [...props.value];
			items.splice(index, 1);
			removeId(index);
			updateValue(items);
		}
		function updateValue(e) {
			emit(VALUE_UPDATE_EVENT, e);
		}
		return (_ctx, _cache) => {
			const _component_dt_text = resolveComponent("dt-text");
			const _component_dt_stack = resolveComponent("dt-stack");
			return openBlock(), createElementBlock(Fragment, null, [
				createVNode(_component_dt_text, {
					as: "div",
					kind: "label",
					size: 100,
					tone: "secondary"
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					_: 3
				}),
				createVNode(_component_dt_text, {
					kind: "code",
					tone: "muted",
					size: 100
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "prefix")]),
					_: 3
				}),
				createElementVNode("div", null, [(openBlock(true), createElementBlock(Fragment, null, renderList(__props.value, (item, index) => {
					return openBlock(), createBlock(_component_dt_stack, {
						key: unref(getId)(index),
						direction: "row"
					}, {
						default: withCtx(() => [createElementVNode("div", _hoisted_1, [renderSlot(_ctx.$slots, "item", {
							item,
							update: (e) => updateItem(index, e)
						})]), createVNode(unref(DtButton), {
							class: "dtc-icon",
							importance: "clear",
							kind: "muted",
							size: 100,
							disabled: __props.disabled,
							onClick: () => removeItem(index)
						}, {
							icon: withCtx(({ iconSize }) => [createVNode(unref(DtIconClose), { size: iconSize }, null, 8, ["size"])]),
							_: 1
						}, 8, ["disabled", "onClick"])]),
						_: 2
					}, 1024);
				}), 128)), createVNode(unref(DtButton), {
					class: "dtc-icon",
					size: 100,
					importance: "clear",
					kind: "muted",
					disabled: __props.disabled,
					onClick: addItem
				}, {
					icon: withCtx(({ iconSize }) => [createVNode(unref(DtIconPlus), { size: iconSize }, null, 8, ["size"])]),
					_: 1
				}, 8, ["disabled"])]),
				createVNode(_component_dt_text, {
					kind: "code",
					tone: "muted",
					size: 100
				}, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "suffix")]),
					_: 3
				})
			], 64);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_iterable.vue.js.map